// BreadDoodle palette as hex ints for three.js materials.
// Mirrors the CSS custom properties in ui/styles.css — keep them in sync.
export const C = {
  cream:     0xFFF4DF,
  toast:     0xEFB96A,
  crust:     0xB5824E,
  crustDark: 0x6E4526,
  cocoa:     0x6B4A2F,
  tangerine: 0xF49B33,
  sprout:    0x7FBF6A,
  sproutDim: 0x5F9E4E,
  raspberry: 0xE6537B,
  cobalt:    0x3D5FC0,
  cobaltDim: 0x2E479A,
  breeze:    0xBEE3EF,
  rye:       0x8C6239,
  white:     0xFFFFFF,
  sink:      0xD8E4E8,
  sky:       0xA5DBF0,
  limb:      0x4A3423,
  grass:     0x8FC96B,
  path:      0xE8D6AE,
  // Coast. World-only (no CSS counterpart) — the Beach, and later the Island.
  sand:      0xE8D6AE,
  sea:       0x4FA8C8,
  seaDeep:   0x2F7FA6,
  foam:      0xEEF8FA,
  // Dressed stone — balustrades, fountains, planters. Uptown is the posh district.
  stone:     0xDED6C4,
  stoneDim:  0xB9AE99
};

// Foliage tint by season. The town's perimeter established these; every outdoor
// zone should plant from the same four colours rather than inventing its own.
export const SEASON_LEAF = {
  spring: C.sprout,
  summer: 0x3A7A2E,
  autumn: 0xC98C3E,
  winter: 0x6A8A7A
};
